import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Yapısal veri (Schema.org) ekleyen bileşen
 * @param {string} type - Schema tipi (organization, dentist, localBusiness, vb.)
 * @returns {JSX.Element} - Helmet bileşeni
 */
const SchemaMarkup = ({ type = 'dentist' }) => {
  // Farklı schema tipleri için veri şablonları
  const schemas = {
    // Diş kliniği için schema
    dentist: {
      "@context": "https://schema.org",
      "@type": "Dentist",
      "name": "Mona Klinik",
      "url": "https://monaklinik.com",
      "logo": "https://monaklinik.com/logo.png",
      "image": "https://monaklinik.com/clinic-image.jpg",
      "description": "Mona Klinik, Kadıköy'de modern diş tedavi hizmetleri sunan uzman kadrosuyla yanınızda.",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Osmanağa Mah. Nal Sk. NO: 11",
        "addressLocality": "Kadıköy",
        "addressRegion": "İstanbul",
        "postalCode": "34710",
        "addressCountry": "TR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "40.9901",
        "longitude": "29.0233"
      },
      "telephone": "+90 0532 294 40 05",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "09:00",
          "closes": "23:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "09:00",
          "closes": "23:00"
        }
      ],
      "sameAs": [
        "https://www.facebook.com/monaklinik",
        "https://www.instagram.com/monaklinik",
        "https://twitter.com/monaklinik"
      ],
      "priceRange": "₺₺"
    },
    
    // Doktor için schema
    doctor: {
      "@context": "https://schema.org",
      "@type": "Physician",
      "name": "Dr. Samet Aksu",
      "jobTitle": "Diş Hekimi",
      "worksFor": {
        "@type": "Dentist",
        "name": "Mona Klinik"
      },
      "description": "Uzman diş hekimi Dr. Samet Aksu, Mona Klinik'te hizmet vermektedir.",
      "image": "https://monaklinik.com/doctor-image.jpg",
      "telephone": "0532 294 40 05",
      "email": "info@monaklinik.com",
      "medicalSpecialty": "Diş Hekimliği"
    },
    
    // Hizmet için schema
    service: {
      "@context": "https://schema.org",
      "@type": "MedicalProcedure",
      "name": "Diş İmplantı",
      "description": "Mona Klinik'te uzman kadromuzla implant tedavisi hizmeti sunuyoruz.",
      "provider": {
        "@type": "Dentist",
        "name": "Mona Klinik",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Osmanağa Mah. Nal Sk. NO: 11",
          "addressLocality": "Kadıköy",
          "addressRegion": "İstanbul",
          "postalCode": "34710",
          "addressCountry": "TR"
        }
      }
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemas[type])}
      </script>
    </Helmet>
  );
};

export default SchemaMarkup; 